import React, { useCallback } from 'react';

import { useTrackModifyCartEvent, createModifyCartEvent, createEcommerceSpecial } from '../../../ecommerce';
import { IGift } from '../../../model';
import { useDeleteGiftAwaitable } from '../../../services';
import { CartActions, ECartActions, IRemoveGiftAction } from '../model';

export const useRemoveGift = (dispatch: React.Dispatch<CartActions>) => {
  const { request } = useDeleteGiftAwaitable();
  const trackModifyCartEvent = useTrackModifyCartEvent();

  return useCallback(
    async (data: IRemoveGiftAction, giftsList: IGift[]) => {
      const result = await request({ itemId: data.itemId });

      const gift = giftsList.find((el) => el.productId === data.productId);

      if (result?.data.products.length) {
        const brand = gift?.brand ?? '';
        const productName = gift?.collection ?? '';

        trackModifyCartEvent({
          ...createModifyCartEvent(1, 0),
          product: createEcommerceSpecial({
            productId: data.productId,
            productCode: data.productCode,
            productName: (brand + ' ' + productName).trim(),
            brandName: brand,
            vat: 0,
            priceSumWithVat: 0,
            count: 0,
            itemId: data.itemId,
            priceWithVat: 0,
          }),
        });

        dispatch({
          actionType: ECartActions.TOGGLE_GIFT_PACKAGING,
          payload: {
            giftPackagings: result.data.serviceItems.giftPackagings,
            pricesSummary: result.data.pricesSummary,
          },
        });

        dispatch({
          actionType: ECartActions.UPDATE_GIFT_SELECTION,
          payload: { giftProductId: data.productId, giftListId: data.giftListId },
        });
      }
    },
    [dispatch, request, trackModifyCartEvent],
  );
};
